import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import Depenses from "@/pages/Depenses";
import Vehicule from "@/pages/Vehicule";
import Statistiques from "@/pages/Statistiques";
import Comptabilite from "@/pages/Comptabilite";
import Parametres from "@/pages/Parametres";
import Clients from "@/pages/Clients";
import Documents from "@/pages/Documents";
import ChargesFixes from "@/pages/ChargesFixes";
import ImportCSV from "@/pages/ImportCSV";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/depenses" element={<Depenses />} />
              <Route path="/statistiques" element={<Statistiques />} />
              <Route path="/vehicule" element={<Vehicule />} />
              <Route path="/comptabilite" element={<Comptabilite />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/charges-fixes" element={<ChargesFixes />} />
              <Route path="/import" element={<ImportCSV />} />
              <Route path="/parametres" element={<Parametres />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
